module.exports = __webpack_public_path__ + "static/media/important.12254dda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/important.svg
// module id = 85
// module chunks = 7